import utils from '../../../utils/utils'

export default {
    getTime01(time){
        return utils.renderTime(time)
    },

}